import { combineReducers } from "redux";
import places from "./places/reducers";

export default combineReducers({ places });
